import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { digitalMedia } from "../apiPath/api";

export const createDigitalMedia = createAsyncThunk(
  "digitalMedia/createDigitalMedia",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await digitalMedia.createDigitalMedia(formData);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const getAllDigitalMedia = createAsyncThunk(
  "digitalMedia/getAllDigitalMedia",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await digitalMedia.getAllDigitalMedia(params);
      return response.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const deleteDigitalMedia = createAsyncThunk(
  "digitalMedia/deleteDigitalMedia",
  async (id, { rejectWithValue }) => {
    try {
      // Adjust API call as per your API utility
      const response = await digitalMedia.deleteDigitalMedia(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const undoDeleteDigitalMedia = createAsyncThunk(
  "digitalMedia/undoDeleteDigitalMedia",
  async (id, { rejectWithValue }) => {
    try {
      const response = await digitalMedia.undoDeleteDigitalMedia(id);
      return response.data.data;
    } catch (error) {
      const backendMsg =
        error.response?.data?.error?.message ||
        error.response?.data?.message ||
        "Login failed";
      return rejectWithValue(backendMsg);
    }
  }
);

export const updateDigitalMedia = createAsyncThunk(
  "digitalMedia/updateDigitalMedia",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await digitalMedia.updateDigitalMedia(id, data);
      return response.data;
    } catch (error) {
      console.error("Update error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to update digital media"
      );
    }
  }
);

const digitalMediaSlice = createSlice({
  name: "digitalMedia",
  initialState: {
    loading: false,
    error: null,
    pagination: { total: 0, page: 1, limit: 10, totalPages: 1 },
    statusCounts: { all: 0, active: 0, inactive: 0, deleted: 0 },
    search: "",
    status: "all",
    limit: 10,
    page: 1,
    success: false,
    digitalMedia: [],
  },

  reducers: {
    resetDigitalMediaState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.digitalMedia = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createDigitalMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createDigitalMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdField = action.payload;
      })
      .addCase(createDigitalMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
      .addCase(getAllDigitalMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllDigitalMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.digitalMedia = action.payload.data;
        state.pagination = action.payload.pagination;
        state.statusCounts = action.payload.statusCounts;
      })
      .addCase(getAllDigitalMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteDigitalMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDigitalMedia.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteDigitalMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(undoDeleteDigitalMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(undoDeleteDigitalMedia.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(undoDeleteDigitalMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateDigitalMedia.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateDigitalMedia.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedField = action.payload;
      })
      .addCase(updateDigitalMedia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  },
});

export const { resetDigitalMediaState } = digitalMediaSlice.actions;
export default digitalMediaSlice.reducer;
